// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"link_DL8jx block text-black text-[0.825rem] leading-[22px] hover_text-blue lg_leading-[30px]"};